import { AxiosPromise } from 'axios';
import {
  ICheckId,
  IGetStaff,
  IStaffParams,
  IGetStaffs,
  IAddCampusReq,
  IEmployeeParams,
  IGetEmployees,
  ICheckMobilePhone,
} from '../models/employees.model';
import axios from 'axios';
import qs from 'qs';

const uri = '/mgmt/employees';

export const getEmployees = (
  params?: IEmployeeParams,
): AxiosPromise<IGetEmployees> => {
  const qsParams = qs.stringify(params);
  return axios.get(`${uri}?${qsParams}`);
};

export const retireEmployee = (
  memberCode: string,
  retireDate: string,
): AxiosPromise => {
  return axios.delete(`${uri}/retire/${memberCode}/${retireDate}`);
};

export const addEmployeeCampus = (
  memberCode: string,
  data: IAddCampusReq,
): AxiosPromise => {
  return axios.post(`${uri}/${memberCode}/campus`, data);
};

export const unlockAccount = (memberCode: string): AxiosPromise => {
  return axios.put(`${uri}/unlock`, { memberCode });
};

export const deleteCampusFromEmployee = (
  memberCode: string,
  campusCode: string,
): AxiosPromise => {
  return axios.delete(`${uri}/${memberCode}/${campusCode}`);
};

/* legacy */

export const checkStaffId = (id: string): AxiosPromise<ICheckId> => {
  return axios.get(`${uri}/idcheck/${id}`);
};

export const checkStaffMobilePhone = (mobilePhone: string): AxiosPromise<ICheckMobilePhone> => {
  return axios.get(`${uri}/mobilecheck/${mobilePhone}`);
};

export const addCampusToStaff = (
  memberCode: string,
  data: IAddCampusReq,
): AxiosPromise => {
  return axios.post(`${uri}/${memberCode}/campus`, data);
};

export const getStaff = (memberCode: string): AxiosPromise<IGetStaff> => {
  return axios.get(`${uri}/${memberCode}`);
};

export const getStaffs = (params?: IStaffParams): AxiosPromise<IGetStaffs> => {
  let _uri = uri;
  const qsParams = qs.stringify(params);
  if (qsParams) _uri += `?${qsParams}`;
  return axios.get(_uri);
};

export const createStaff = (data: any): AxiosPromise => {
  return axios.post(uri, data);
};

export const updateStaff = (id: string, data: any): AxiosPromise => {
  return axios.put(`${uri}/${id}`, data);
};

export const updatePassword = (id: string, data: any): AxiosPromise => {
  return axios.put(`${uri}/pass/${id}`, data);
};

//20240716 직원 재직 상태 리스트
export const findEmployeeStatus = (): AxiosPromise => {
  return axios.get(`${uri}/employeeStatus`);
};
